<template>
  <ion-page>
    <ion-header mode="ios" class="ion-no-border">
      <ion-toolbar>
        <ion-buttons slot="start" hide-back-button="true">
          <ion-back-button text="" default-href="/sale/customers"></ion-back-button>
        </ion-buttons>
        <ion-title>{{
          $t('add') + ' ' + ($route.query.headId ? $t('customerPage.branch') : $t('company'))
        }}</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content :fullscreen="true" @touchstart="handleScroll($event)">
      <step-form :key="Date.now()" />
    </ion-content>
  </ion-page>
</template>

<script>
import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';
import { isPlatform } from '@ionic/vue';
import StepForm from './StepForm.vue';
export default {
  name: 'AddCustomer',
  components: {
    StepForm
  },
  setup() {
    const handleScroll = (event) => {
      if (event && Capacitor.isNativePlatform() && !isPlatform('ios')) {
        Keyboard.hide();
      }
    };
    return {
      handleScroll
    };
  }
};
</script>
<style src="@/assets/css/newdesign.scss" lang="scss" scoped></style>
